import React from 'react'
import PropTypes from 'prop-types'
import { MicroFrontendLoader } from 'src/views/components/MicroFrontends/MicroFrontendLoader'

/**
 * Presentational component for the My Accounts micro-frontend.
 * Renders the remote MFE via `MicroFrontendLoader` using the provided
 * `remoteConfig` and `params`. All orchestration (pubsub subscriptions,
 * routing handlers, customer-data wiring) lives in `MyAccountMFEContainer`.
 */
const MyAccountMFE = ({ remoteConfig, params }) => (
  <MicroFrontendLoader remoteConfig={remoteConfig} params={params} />
)

MyAccountMFE.propTypes = {
  remoteConfig: PropTypes.shape({
    appName: PropTypes.string.isRequired,
    component: PropTypes.string.isRequired,
  }).isRequired,
  params: PropTypes.object,
}

MyAccountMFE.defaultProps = {
  params: {},
}

export { MyAccountMFE }
export default MyAccountMFE
